/* Apply the theme's review order through Judge.me's own sorting control.
 * Judge.me mounts asynchronously and can replace controls when changing tabs.
 */
(() => {
  'use strict';

  const defaultSort = document.currentScript?.dataset.defaultSort;
  if (defaultSort !== 'highest_rating') return;

  const controlSelector = 'select.jdgm-sort-dropdown';
  const widgetSelector = '.jdgm-review-widget, .jdgm-all-reviews-page, .jdgm-revs-tab';
  const choices = new WeakMap();
  const applying = new WeakSet();
  const attempts = new WeakMap();
  let scheduled = false;

  const normalize = value => value.replace(/-/g, '_');
  const widgetFor = control => control.closest(widgetSelector) || control.parentElement;

  function applyDefault(control) {
    const widget = widgetFor(control);
    const preferred = choices.get(widget) || defaultSort;
    const option = Array.from(control.options).find(item => normalize(item.value) === preferred);
    if (!option || control.disabled || control.value === option.value) return;

    // A failed or incompatible widget must not cause an endless request loop.
    const count = attempts.get(control) || 0;
    if (count >= 3) return;
    attempts.set(control, count + 1);

    applying.add(control);
    try {
      control.value = option.value;
      // This asks Judge.me to fetch and paginate reviews in the chosen order.
      control.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      applying.delete(control);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll(controlSelector).forEach(applyDefault);
    });
  }

  document.addEventListener('change', event => {
    const control = event.target;
    if (!(control instanceof HTMLSelectElement) || !control.matches(controlSelector) || applying.has(control)) return;
    // Keep a visitor's subsequent choice through pagination and widget rerenders.
    choices.set(widgetFor(control), normalize(control.value));
    attempts.delete(control);
  }, true);

  function start() {
    const observer = new MutationObserver(records => {
      const relevant = records.some(record => {
        if (record.type === 'attributes') return record.target.matches(controlSelector);
        if (record.target.nodeType === 1 && record.target.closest(widgetSelector)) return true;
        return Array.from(record.addedNodes).some(node => node.nodeType === 1 && (
          node.matches(controlSelector) || node.querySelector(controlSelector)
        ));
      });
      if (relevant) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
